<template>
  <div class="signature-pad-wrapper">
    <canvas
      ref="canvas"
      class="signature-canvas"
      @mousedown="startDrawing"
      @mousemove="draw"
      @mouseup="stopDrawing"
      @mouseleave="stopDrawing"
      @touchstart.prevent="handleTouchStart"
      @touchmove.prevent="handleTouchMove"
      @touchend.prevent="stopDrawing"
    />
    <div class="signature-pad-actions mt-1">
      <b-button size="sm" variant="outline-secondary" @click="clearCanvas">
        Clear Signature
      </b-button>
      <small v-if="!hasDrawn" class="text-muted ml-1">Draw your signature above</small>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'DigitalAgreementSignaturePad',
  components: { BButton },
  data() {
    return {
      drawing: false,
      hasDrawn: false,
      context: null,
    }
  },
  mounted() {
    this.initCanvas()
    window.addEventListener('resize', this.initCanvas)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initCanvas)
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) return
      const rect = canvas.getBoundingClientRect()
      const ratio = window.devicePixelRatio || 1
      canvas.width = rect.width * ratio
      canvas.height = rect.height * ratio
      this.context = canvas.getContext('2d')
      this.context.scale(ratio, ratio)
      this.context.strokeStyle = '#1a1a2e'
      this.context.lineWidth = 2
      this.context.lineCap = 'round'
      this.context.lineJoin = 'round'
    },
    getPointerPosition(event) {
      const rect = this.$refs.canvas.getBoundingClientRect()
      const clientX = event.touches ? event.touches[0].clientX : event.clientX
      const clientY = event.touches ? event.touches[0].clientY : event.clientY
      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      }
    },
    startDrawing(event) {
      this.drawing = true
      const pos = this.getPointerPosition(event)
      this.context.beginPath()
      this.context.moveTo(pos.x, pos.y)
    },
    draw(event) {
      if (!this.drawing) return
      const pos = this.getPointerPosition(event)
      this.context.lineTo(pos.x, pos.y)
      this.context.stroke()
      this.hasDrawn = true
    },
    handleTouchStart(event) {
      this.startDrawing(event)
    },
    handleTouchMove(event) {
      this.draw(event)
    },
    stopDrawing() {
      this.drawing = false
    },
    clearCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas || !this.context) return
      this.context.clearRect(0, 0, canvas.width, canvas.height)
      this.hasDrawn = false
      this.initCanvas()
    },
    getSignatureDataUrl() {
      if (!this.hasDrawn || !this.$refs.canvas) return null
      return this.$refs.canvas.toDataURL('image/png')
    },
  },
}
</script>

<style scoped>
.signature-pad-wrapper {
  width: 100%;
}

.signature-canvas {
  display: block;
  width: 100%;
  height: 160px;
  border: 2px dashed #c8c8d8;
  border-radius: 8px;
  background: #fafafa;
  cursor: crosshair;
  touch-action: none;
}

@media (max-width: 576px) {
  .signature-canvas {
    height: 140px;
  }
}
</style>
